// PaymentModal.js
import './PaymentModal.css'; // Keep the existing CSS
import { useEffect, useRef } from 'react';
// import payU from '../../images/payu.webp'
import paytm from '../../images/paytm.png'

// const PaymentModal = ({ onClose, onPayu, onPaytm, isLoading }) => {
const PaymentModal = ({ onClose, onPayu, onPaytm, isLoading, errorMessage }) => {
  // Auto-start the Paytm flow once, as soon as the modal opens.
  // The ref guard stops React StrictMode's double-invoked effect (dev)
  // and any re-render from firing onPaytm more than once.
  const autoStarted = useRef(false);
  useEffect(() => {
    if (autoStarted.current) return;
    autoStarted.current = true;
    onPaytm?.();
  }, [onPaytm]);

  const hasError = Boolean(errorMessage);

  return (
    <div className="modal-overlay">
      <div className="modal-content payment-popup">
        <h3>{hasError ? "Payment Failed" : "Redirecting to Paytm…"}</h3>

        {hasError && (
          <p
            id="paytmErrorMessage"
            style={{
              color: "#d32f2f",
              background: "#fdecea",
              border: "1px solid #f5c6cb",
              borderRadius: "6px",
              padding: "10px 12px",
              margin: "12px 0",
              fontSize: "14px",
              textAlign: "center",
            }}
          >
            {errorMessage}
          </p>
        )}

        <div className="modal-actions" style={{ display: "flex", justifyContent: "center" }}>
          <img
            src={paytm}
            alt="Pay with Paytm"
            className="pay-image paytm-image"
            onClick={onPaytm}
            style={{width:"20%",marginRight:"30px", cursor: isLoading ? 'not-allowed' : 'pointer', opacity: isLoading ? 0.5 : 1 }}
          />
          {/* <img
            src={payU}
            alt="Pay with PayU"
            className="pay-image payu-image"
            onClick={onPayu}
            style={{width:"14%", cursor: isLoading ? 'not-allowed' : 'pointer', opacity: isLoading ? 0.5 : 1 }}
          /> */}
          {hasError && (
            <h5
              onClick={isLoading ? undefined : onPaytm}
              style={{ cursor: isLoading ? "not-allowed" : "pointer", color: "#0a58ca" }}
            >
              {/* {isLoading ? "Please wait…" : "Retry Paytm"} */}
              {isLoading ? "Please wait…" : "Retry"}
            </h5>
          )}
        </div>

        <button
          className=" btn btn-secondary mx-auto px-5 btn-lg "
          onClick={onClose}
        >
          {hasError ? "Close" : "Cancel"}
        </button>
      </div>
    </div>
  );
};

export default PaymentModal;